<nav class="navbar">
  <img class="navbar-brand logo" src="assets/img/app-logo.svg" alt="App Logo" />
  <form class="form-inline mr-5">
    <app-dropdown
      [items]="languages"
      [selectedItem]="languageSelected"
      [class]="'btn-no-lines'"
      (onEmit)="changeSelectLang($event)"
    >
    </app-dropdown>
  </form>
</nav>
 

<div
  class="signin-wrapper loginContain justify-content-center align-items-center"
>
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-8 col-lg-5">
        <form
          [formGroup]="formdata"
          name="formdata"
          (ngSubmit)="onClickSubmit(formdata.value)"
          #ngForm="ngForm"
        > 
          <p class="title_blue" *ngIf="isDesktop"> 
            {{ 'AUTHORIZATION.SIGN_IN' | translate }}
          </p>

          <div class="col-12 p-0">
            <label class="input-floating mb-40 mb-2">
              <input
                class="form-input"
                inputSanitizer
                type="text"
                id="enterUsername"
                name="username"
                aria-describedby="emailHelp"
                maxlength="100"
                placeholder="{{
                  translationKeys.Authorization.UsernamePlaceholder | translate
                }}"
                required
                autofocus
                formControlName="username"
                [ngClass]="{ 
                  invalidForm: formdata.get('username').errors &&
                  (formdata.get('username').dirty || ngForm.submitted) || 
                  !validCredentials
                }"
              />

              <span>{{
                translationKeys.Authorization.Username | translate
              }}</span>
            </label>

            <div
              class="invalidFormMessage mb-4"
              *ngIf="
              formdata.get('username').errors &&
              (formdata.get('username').dirty || ngForm.submitted) 
              "
            >
              <span *ngIf="formdata.get('username').errors?.required">
                {{ translationKeys.ErrorMessages.RequiredUserName | translate }}
              </span>
            </div>
          </div>

          <div class="col-12  p-0">
            <label class="input-floating mb-40 mb-2">
              <input
                class="form-input"
                inputSanitizer
                [type]="showPassword ? 'text' : 'password'"
                id="enterPassword"
                name="password"
                maxlength="25"
                placeholder="{{
                  translationKeys.Authorization.PasswordPlaceholder | translate
                }}"
                required
                formControlName="password"
                [ngClass]="{
                  invalidForm: formdata.get('password').errors &&
                  (formdata.get('password').dirty || ngForm.submitted) || 
                  !validCredentials
                }"
              />
              <span>{{ translationKeys.Authorization.Password | translate }}</span>

              <span class="viewPassword">
                <img
                  [ngClass]="{ active: showPassword }"
                  [src]="
                    showPassword
                      ? 'assets/ph-bhp-layout/svg/icon-view.svg'
                      : 'assets/ph-bhp-layout/svg/eye-close.svg'
                  "
                  alt="view password"
                  (click)="viewPassword()"
                />
              </span>

             
            </label>

            <div
              class="invalidFormMessage mb-4"
              *ngIf="
              formdata.get('password').errors &&
              (formdata.get('password').dirty || ngForm.submitted)
              "
            >
              <span *ngIf="formdata.get('password').errors?.required">
                {{ translationKeys.ErrorMessages.RequiredPassword | translate }}
              </span>
            </div>
          </div>

          <div class="col-12 mt-2 p-0">
            <button
              type="submit"
              class="col-12 btn btn-bd" 
              [ngClass]="{
                invalidButton:
                !ngForm.valid
              }"
            >
              {{ translationKeys.Authorization.Login | translate }}
            </button>
          </div>

          <div class="form-group text-center mt-2">
            <a (click)="changePassword()" class="forgotPass">
              {{ 'AUTHORIZATION.FORGOT_PASSWORD' | translate }}
            </a>
          </div>
        </form>

        <div class="mt-5 disclaimer">
          {{
            "AUTHORIZATION.USAGE_REQUIRES_REGISTRATION_BY_INSTITUTION_ADMIN"
              | translate
          }}
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #template2>
  <div class="modal-header justify-content-between align-items-center">
    <h5 class="modal-title">
      {{ translationKeys.Authorization.LegalNotice | translate }}
    </h5>
  </div>
  <div
    class="modal-body"
    data-simplebar
    [innerHtml]="htmlToAddLegalNotice"
  ></div>
  <div class="modal-footer">
    <div class="container-fluid">
      <div class="row my-3">
        <div class="col justify-content-center align-items-center d-flex">
          <button
            (click)="checkModel = false; modalRef.hide()"
            class="btn btn-cancel"
          >
            {{ translationKeys.InstitutionManagement.Close | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #template3>
  <div class="modal-header justify-content-between align-items-center">
    <h5 class="modal-title">{{ "GENERAL.DATA_PROTECTION" | translate }}</h5>
  </div>
  <div
    class="modal-body"
    data-simplebar
    [innerHtml]="htmlToAddDataProtection"
  ></div>
  <div class="modal-footer">
    <div class="container-fluid">
      <div class="row my-3">
        <div class="col justify-content-center align-items-center d-flex">
          <button
            (click)="checkModel = false; modalRef.hide()"
            class="btn btn-cancel"
          >
            {{ translationKeys.InstitutionManagement.Close | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #needRefresh>
  <div class="modal-header justify-content-center align-items-center">
    <h5 class="modal-title">{{ "DIALOG.WEBSITEVERSION.TITLE" | translate }}</h5>
  </div>
  <div class="modal-body">
    <p class="text-center">
      {{ "DIALOG.WEBSITEVERSION.MESSAGE" | translate }}
    </p>
  </div>
  <div class="modal-footer">
    <div class="container-fluid">
      <div class="col-12 justify-content-center align-items-center d-flex">
        <button (click)="refreshPage()" class="btn btn-primary">
          {{ "CONFIGURE.ACCEPT" | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #selectUsers> 

  <div class="container-fluid">

    <div class="d-flex justify-content-end mt-3">
      <a class="cursor" data-dismiss="modal" (click)="modalRef.hide()"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>

    <h5 class="modal-title-elearning">{{ "CONFIGURE.SELECT_USER" | translate }}</h5>
  
  </div>
  <div
    class="modal-body"
    data-simplebar
    class="change-lang"
    style="max-height: 400px"
  >

    <form [formGroup]="userGroup" class=" mx-3 mt-3  form-elearning">
      <div  *ngFor="let aUser of usersList; let i = index"
        class="form-check users   py-3" 
      >
      <div class="overflow-auto"  style="max-height: 244px;">
        <input
          type="radio"
          formControlName="selecteduser"
          [value]="aUser"
          name="selecteduser"
          class="form-check-input-elearning"
          [id]="'user' + i"
        />
        <label class="form-check-label" [for]="'user' + i"
          ><b>{{ aUser.username }}</b> [ {{ aUser.role.roleName }} ]</label
        >    
      </div>
      </div>
    </form>
  </div>
  <div class="modal-footer mt-3 mr-2">
    <div class="container-fluid">
      <div class="row k-justify-content-right"> 
          <button type="button" class="btn-cancel-bordered-bd mr-2" (click)="closemodal()" >{{ "Cancel" | translate }}</button>
          <button type="button" class="btn-continue-bordered-bd" (click)="selectUser()">{{ "Continue" | translate }}</button>
      </div>
    </div>
  </div>  
  
</ng-template>

<app-toast></app-toast>





